import { render, staticRenderFns } from "./IcoWorkspaceCreated.vue?vue&type=template&id=4efe387e&lang=html"
import script from "./IcoWorkspaceCreated.vue?vue&type=script&lang=js"
export * from "./IcoWorkspaceCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports